"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

var _icons = require("@material-ui/icons");

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var styles = function styles(theme) {
  return {
    root: {
      alignSelf: 'center',
      height: '100%',
      display: 'grid',
      gridTemplateRows: '1fr',
      gridTemplateColumns: 'repeat(3, minMax(48px, 64px)) 1fr',
      placeItems: 'center'
    },
    selfAlignStart: {
      justifySelf: 'start'
    },
    selfAlignEnd: {
      justifySelf: 'end'
    },
    iconButton: {
      padding: 0,
      color: 'white'
    },
    iconColor: {
      color: theme.palette.primary.contrastText
    },
    withSidebar: {
      color: 'black'
    },
    tooltip: {
      fontSize: '0.9rem !important'
    }
  };
};

var Zoom = function Zoom(props) {
  var _classNames;

  var classes = props.classes,
      setZoom = props.setZoom,
      resetZoom = props.resetZoom,
      withSidebar = props.withSidebar,
      _props$alignZoomEnd = props.alignZoomEnd,
      alignZoomEnd = _props$alignZoomEnd === void 0 ? false : _props$alignZoomEnd;
  var rootClass = (0, _classnames.default)(classes.root, (_classNames = {}, _defineProperty(_classNames, classes.selfAlignStart, !alignZoomEnd), _defineProperty(_classNames, classes.selfAlignEnd, alignZoomEnd), _classNames));
  var iconClass = (0, _classnames.default)(classes.iconButton, _defineProperty({}, classes.withSidebar, withSidebar));
  return _react.default.createElement("div", {
    className: rootClass
  }, _react.default.createElement(_core.Tooltip, {
    title: "Zoom In",
    enterDelay: 500,
    classes: {
      tooltip: classes.tooltip
    }
  }, _react.default.createElement(_core.IconButton, {
    className: classes.iconButton,
    onClick: function onClick() {
      return setZoom(0.25);
    },
    "data-test-id": "Zoom-zoomInButton"
  }, _react.default.createElement(_icons.ZoomIn, {
    style: {
      fontSize: 39
    },
    className: iconClass
  }))), _react.default.createElement(_core.Tooltip, {
    title: "Zoom Out",
    enterDelay: 500,
    classes: {
      tooltip: classes.tooltip
    }
  }, _react.default.createElement(_core.IconButton, {
    className: classes.iconButton,
    onClick: function onClick() {
      return setZoom(-0.25);
    },
    "data-test-id": "Zoom-zoomOutButton"
  }, _react.default.createElement(_icons.ZoomOut, {
    style: {
      fontSize: 39
    },
    className: iconClass
  }))), _react.default.createElement(_core.Tooltip, {
    title: "Reset to Actual Size",
    enterDelay: 500,
    classes: {
      tooltip: classes.tooltip
    }
  }, _react.default.createElement(_core.IconButton, {
    className: classes.iconButton,
    onClick: resetZoom,
    "data-test-id": "Zoom-zoomResetButton"
  }, _react.default.createElement(_icons.YoutubeSearchedFor, {
    style: {
      fontSize: 39
    },
    className: iconClass
  }))));
};

Zoom.propTypes = {
  classes: _propTypes.default.object.isRequired
};

var _default = (0, _styles.withStyles)(styles)(Zoom);

exports.default = _default;